import { render, staticRenderFns } from "./OpenCartStock.vue?vue&type=template&id=457f859c&"
import script from "./OpenCartStock.vue?vue&type=script&lang=js&"
export * from "./OpenCartStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartStock.vue"
export default component.exports